import React from 'react';
import { observer } from 'mobx-react';
import './checkbox.scss';

interface ICheckbox {
  classAdmin?: string;
  label?: string;
  id: string;
  name: string;
  checked: boolean;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

const CheckboxComponent = (props: ICheckbox) => {
  return (
    <div>
      <input
        className="usa-checkbox__input"
        id={props.id}
        data-testid="the-Checkbox"
        type="checkbox"
        name={props.name}
        checked={props.checked}
        onChange={props.onChange}
      />
      <label className={`usa-checkbox__label align-items-center ${props.classAdmin}`} htmlFor={props.id}>
        {props.label}
      </label>
    </div>
  );
};

export const Checkbox = observer(CheckboxComponent);
